/**
 * Dinero de suscripciones, compartido entre la pantalla y la tarjeta del Home.
 * Cuando Apple persiste el precio real cobrado (realPrice {amount, currency})
 * se convierte con tipos aproximados; Google no lo guarda y usa referencia.
 */
export const PLAN_EUR = { monthly: 5.99, yearly: 49.9 };
export const LIFETIME_EUR = 149.9;
export const FX = {
  EUR: 1, USD: 0.85, GBP: 1.17, CHF: 1.07, RUB: 0.0095, ILS: 0.26, HKD: 0.109,
  IDR: 0.000052, KZT: 0.0016, CNY: 0.12, AUD: 0.56, TWD: 0.028, SGD: 0.66,
  PHP: 0.015, MXN: 0.046, NZD: 0.51, ZAR: 0.048, PEN: 0.24, SAR: 0.227,
  TRY: 0.02, BRL: 0.16, NGN: 0.00057, NOK: 0.085, MYR: 0.2, KRW: 0.00062,
  PLN: 0.235, CAD: 0.62, VND: 0.000033, THB: 0.026, HUF: 0.0026, RON: 0.2,
  COP: 0.00021, JPY: 0.0057, INR: 0.0095, DKK: 0.134, SEK: 0.09, CZK: 0.041,
};
export const rowPrice = (r) => (r.realPrice && FX[r.realPrice.currency] != null ? r.realPrice.amount * FX[r.realPrice.currency] : null);
export const chargeEur = (r, kind) => (kind === "lifetime" ? rowPrice(r) ?? LIFETIME_EUR : rowPrice(r) ?? PLAN_EUR[r.plan] ?? 0);
export const ltvOf = (r) => (r.payments ?? []).reduce((a, p) => a + chargeEur(r, p.kind), 0);
